import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { Subscription, Subject, Observable, throwError } from "rxjs";
import { isArray } from "util";
import { CustomHttpClientService } from "../service/custom-http-client.service";
import { catchError } from "rxjs/operators";
declare var $: any;

@Injectable()
export class FeedService {
  url = environment.apiUrl;
  token = localStorage.getItem("token");

  private timer;
  private sub: Subscription;
  public _feed$: Subject<{}>;
  private socketInitialized = false;

  constructor(private http: CustomHttpClientService) {
    this._feed$ = <Subject<{}>>new Subject();
    this.token = localStorage.getItem("token");

    // Wait for document to be ready before initializing socket
    $(document).ready(() => {
      setTimeout(() => {
        this.initializeSocketConnection();
      }, 500);
    });
  }

  get feed$() {
    return this._feed$.asObservable();
  }

  private initializeSocketConnection() {
    if (this.socketInitialized) {
      return;
    }

    if (!self["io"] || !self["io"].socket) {
      console.error("Socket.io not initialized");
      return;
    }

    this.socketInitialized = true;

    // Get building IDs from localStorage
    const currentBuildingId = localStorage.getItem("userBuildingId");
    if (currentBuildingId) {
      const buildingIds = currentBuildingId.split(",");

      // Initial connection
      self["io"].socket.get("/feed", {
        extraHeaders: {
          authorization: this.token,
        },
      });

      // Explicitly join each building room
      buildingIds.forEach((buildingId) => {
        console.log(`Joining room for building: building_${buildingId}`);
        self["io"].socket.get(`/feed/join-room/${buildingId}`, {
          extraHeaders: {
            authorization: this.token,
          },
        });
      });
    }

    // Set up listeners
    this.setupSocketListeners();
  }

  private processedFeedIds: Set<string> = new Set();

  private setupSocketListeners() {
    // Remove existing listeners to prevent duplicates
    self["io"].socket.off("connect");
    self["io"].socket.off("disconnect");
    self["io"].socket.off("feedcontroller");
    self["io"].socket.off("activityfeed");
    self["io"].socket.off("newAlert");

    // Connection status logging
    self["io"].socket.on("connect", () => {
      console.log("Socket connected with ID:", self["io"].socket.id);

      // Re-join all rooms on reconnect
      this.initializeSocketConnection();
    });

    self["io"].socket.on("disconnect", () => {
      console.log("Socket disconnected - attempting to reconnect...");
      this.socketInitialized = false;

      // Reconnect with delay
      setTimeout(() => this.initializeSocketConnection(), 3000);
    });

    // Feed updates - improved handling of data
    self["io"].socket.on("activityfeed", (data) => {
      console.log("Activity feed update received:", data);
      console.log("RAW Socket data received:", data);
      console.log("Data structure:", {
        hasFeeds: !!data.feeds,
        hasComments: !!data.comments,
        hasEvents: !!data.events,
        hasMaintenance: !!data.maintenance,
        hasData: !!data.data,
        verb: data.verb,
        buildingId: data.buildingId,
      });

      let normalizedData;

      if (data && typeof data === "object") {
        // Handle the verb: 'created' format (new posts)
        if (data.verb === "upvoted" && data.data) {
          normalizedData = data.data;
          console.log("Found upvote data:", data.data);
          console.log("Upvote details:", {
            feedId: data.data.id,
            votes: data.votes || data.data.votes,
            isNewVote: data.isNewVote,
            userId: data.userId,
          });
          // Emit with feeds wrapper
          this._feed$.next({ feeds: normalizedData });
          return;
        }
        if (data.verb === "created" && data.data) {
          normalizedData = data.data;
          console.log("Found created post data:", normalizedData);
          // Emit with feeds wrapper for new posts
          this._feed$.next({ feeds: normalizedData });
          return;
        }
        // Handle comments format
        else if (data.comments || (data.data && data.data.comments)) {
          console.log(" Found comments data:", data.comments);
          this._feed$.next({ comments: data.comments });
          return;
        }
        // Handle events format
        else if (data.events || (data.data &&data.data.events)) {
          console.log("Found events data:", data.events);
          this._feed$.next({ events: data.events });
          return;
        }
        // Handle maintenance format
        else if (
         (data && data.maintenance) ||
         (data && data.type === "maintenance") ||
         (data && data.data && data.data.maintenance) ||
         (data && data.data && data.data.type === "maintenance")
        ) {
          console.log("Found maintenance data:", data.maintenance);
          this._feed$.next({ maintenance: data.maintenance });
          return;
        }
        // Handle recommendation format
        else if (
          (data && data.recommendation) ||
          (data && data.type === "recommendation") ||
          (data && data.data && data.data.recommendation) ||
          (data && data.data && data.data.type === "recommendation")
        ) {
          console.log("Found recommendation data:", data.recommendation);
          this._feed$.next({ recommendation: data.recommendation });
          return;
        }
        // Handle replies format
        else if (data.replies || (data.data && data.data.replies)) {
          console.log("Found replies data:", data.replies);
          this._feed$.next({ replies: data.replies });
          return;
        }
        // If none of the above specific types, and it has 'data' property, use that
        else if (data.data) {
          normalizedData = data.data;
        }
        // Default case, if it's a direct feed object with an ID
        else {
          normalizedData = data;
        }
      } else {
        normalizedData = data;
      }

      // Only process if we have valid data with an ID and it hasn't been processed as a specific type
      if (normalizedData && normalizedData.id) {
        // Mark new posts
        if (!this.processedFeedIds.has(normalizedData.id)) {
          normalizedData.isNew = true;
          this.processedFeedIds.add(normalizedData.id);
        }

        // Ensure buildingId is in the correct format
        normalizedData = this.ensureCorrectBuildingIdFormat(normalizedData);

        // Log and emit the normalized data to subscribers, always wrapped in 'feeds'
        console.log(
          " Emitting normalized data to subscribers (wrapped in feeds):",
          normalizedData
        );
        this._feed$.next({ feeds: normalizedData });
      }
    });

    self["io"].socket.on("maintenance", (data) => {
      let normalizedData;

      switch (data.verb) {
        case "created":
          if (data.data) {
            normalizedData = data.data;
            this._feed$.next({ maintenance: normalizedData });
          }
          break;
        //commented

        case "updated":
          if (data.data) {
            normalizedData = data.data;
            this._feed$.next({ maintenance: normalizedData });
          }
          break;

        case "commented":
          if (data.data) {
            normalizedData = data.data;
            this._feed$.next({ maintenance: normalizedData });
          }
          break;

        case "deleted":
          if (data.data && data.id) {
            this._feed$.next({ maintenance: normalizedData });
          }
          break;

        case "upvoted":
          if (data.data) {
            normalizedData = data.data;
            this._feed$.next({ maintenance: normalizedData });
          }
          break;

        default:
          if (data.data) {
            normalizedData = data.data;
            this._feed$.next({ maintenance: normalizedData });
          }
          break;
      }
    });

    self["io"].socket.on("comment", (data) => {
      console.log("Comment event received:", data);
      console.log("Comment data structure:", {
        hasComments: !!data.comments,
        verb: data.verb,
        buildingId: data.buildingId,
        isDelete: !!data.delete,
        commentId: data.commentId,
      });

      if (data && typeof data === "object") {
        if (data.delete === true || data.verb === "comment_deleted") {
          console.log("Found comment deletion data:", data);
          const deleteEvent = {
            comments: {
              id: data.commentId,
              activityFeed: data.activityFeedId,
              delete: true,
            },
          };
          this._feed$.next(deleteEvent);
          return;
        }

        if (
          data.verb === "comment_flagged" ||
          data.verb === "comment_unflagged"
        ) {
          console.log(`Found comment ${data.verb} data:`, data.comments);

          // Add the activity feed reference based on the comment type
          const commentData = { ...data.comments };

          // Set the appropriate activity feed ID
          if (commentData.maintenance) {
            commentData.activityFeed = commentData.maintenance;
          } else if (commentData.event) {
            commentData.activityFeed = commentData.event;
          }

          // Mark as updated for flag/unflag operations
          commentData.updated = true;
          commentData.flag = true;

          this._feed$.next({ comments: commentData });
          return;
        }

        if (data.comments) {
          console.log("Found comments data:", data.comments);
          this._feed$.next({ comments: data.comments });
          return;
        }
      }
    });

    self["io"].socket.on("reply", (data) => {
      console.log("reply event received then:", data);
      console.log("reply data structure:", {
        hasComments: !!data.replies,
        verb: data.verb,
        buildingId: data.buildingId,
      });

      if (data && typeof data === "object") {
        if (data.replies) {
          console.log(" Found replies data:", data.replies);
          this._feed$.next({ replies: data.replies });
          return;
        }
      }
    });

    self["io"].socket.on("events", (data) => {
      let normalizedData;

      switch (data.verb) {
        case "created":
          if (data.data) {
            normalizedData = data.data;
            this._feed$.next({ events: normalizedData });
          }
          break;

        case "updated":
          if (data.data) {
            normalizedData = data.data;
            this._feed$.next({ events: normalizedData });
          }
          break;

        case "attendance_updated":
          if (data.data) {
            normalizedData = data.data;
            this._feed$.next({ events: normalizedData });
          }
          break;

        case "commented":
          if (data.data) {
            normalizedData = data.data;
            this._feed$.next({ events: normalizedData });
          }
          break;

        case "deleted":
          if (data.data && data.id) {
            normalizedData = data.data;
            this._feed$.next({ events: normalizedData });
          }
          break;

        case "upvoted":
          if (data.data) {
            normalizedData = data.data;
            this._feed$.next({ events: normalizedData });
          }
          break;

        default:
          if (data.data) {
            normalizedData = data.data;
            this._feed$.next({ events: normalizedData });
          }
          break;
      }
    });

    self["io"].socket.on("post", (data) => {
      let normalizedData;
      console.log("post event received then:", data);
     	 if (data.verb === "created" && data.data) {
      	   normalizedData = data.data;
      	   this._feed$.next({ feeds: normalizedData });
           return;
       }
    });

    // Similar improvement for new alerts
    self["io"].socket.on("newAlert", (alert) => {
      console.log("New alert received:", alert);
      if (alert && alert.id) {
        alert = this.ensureCorrectBuildingIdFormat(alert);
        this._feed$.next({ alerts: alert });
      }
    });
  }

  // This is the key function to fix building IDs
  private ensureCorrectBuildingIdFormat(feed) {
    if (!feed) return feed;

    console.log("Original buildingId:", feed.buildingId);

    // If buildingId exists but isn't an array, convert it
    if (feed.buildingId && !Array.isArray(feed.buildingId)) {
      feed.buildingId = [feed.buildingId];
    }

    // If it doesn't exist but there's a builds array, use that
    if (
      (!feed.buildingId || feed.buildingId.length === 0) &&
      feed.builds &&
      Array.isArray(feed.builds)
    ) {
      feed.buildingId = feed.builds.map((id) => {
        return { id: id };
      });
    }

    // If buildingId exists but isn't in object format, convert to {id: value}
    if (feed.buildingId && Array.isArray(feed.buildingId)) {
      feed.buildingId = feed.buildingId.map((item) => {
        if (typeof item === "string" || typeof item === "number") {
          return { id: item };
        } else if (typeof item === "object" && item !== null) {
          if (!item.id && item.buildingId) {
            return { id: item.buildingId };
          }
          return item;
        }
        return item;
      });
    }

    // Make sure selected building is included in buildingId
    let currentBuildingId = localStorage.getItem("userBuildingId");
    let selectedBuildingId = localStorage.getItem("selectedBuildingId"); // This might be set in your component

    console.log("Current Building IDs from localStorage:", currentBuildingId);
    console.log("Selected Building ID:", selectedBuildingId);

    if (currentBuildingId) {
      let buildingIds = currentBuildingId.split(",");
      console.log("Split Building IDs:", buildingIds);

      let feedHasCurrentBuilding = false;

      if (feed.buildingId && Array.isArray(feed.buildingId)) {
        console.log("Feed buildingId objects:", feed.buildingId);

        for (let buildingId of buildingIds) {
          if (feed.buildingId.some((b) => b.id === buildingId)) {
            feedHasCurrentBuilding = true;
            console.log("Feed contains building ID:", buildingId);
            break;
          }
        }

        // If feed doesn't include current building, add it
        if (!feedHasCurrentBuilding && buildingIds.length > 0) {
          feed.buildingId.push({ id: buildingIds[0] });
          console.log("Added current building to feed:", buildingIds[0]);
        }

        // Also add the selected building ID if it's available
        if (
          selectedBuildingId &&
          !feed.buildingId.some((b) => b.id === selectedBuildingId)
        ) {
          feed.buildingId.push({ id: selectedBuildingId });
          console.log("Added selected building to feed:", selectedBuildingId);
        }
      }
    }

    console.log("Final normalized buildingId:", feed.buildingId);
    return feed;
  }

  getAllFeeds() {
    this.initializeSocketConnection();
  }

  // Rest of your methods remain unchanged...

  getPost(userId: string): Observable<any> {
    const formData: FormData = new FormData();
    const building = localStorage.getItem("buildingresidents");
    console.log(building, "^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^");
    const id = localStorage.getItem("residents");

    formData.append("building", building || "");
    formData.append("id", userId);

    return this.http
      .post<any>(`${this.url}feed/getFeedsByBuilding`, formData)
      .pipe(catchError(this.handleError));
  }

  getAllPost(id: any): Observable<any> {
    return this.http.get<any>(this.url + "feed/getAllPost/?id=" + id);
  }

  getAllTypePost(
    id: any,
    skip: any,
    limit: any,
    buildingId: any,
    initialLoad = false,
    type = null
  ): Observable<any> {
    return this.http.get<any>(
      this.url +
        "feed/getAllTypePost/?id=" +
        id +
        "&skip=" +
        skip +
        "&limit=" +
        limit +
        "&buildingId=" +
        buildingId +
        "&initialLoad=" +
        initialLoad +
        "&type=" +
        type
    );
  }

  getUsers(): Observable<any> {
    let formData: FormData = new FormData();
    let building = localStorage.getItem("buildingresidents");
    let id = localStorage.getItem("residents");
    formData.append("building", building);
    formData.append("id", id);
    return this.http.post<any>(this.url + "feed/getUsers", formData);
  }

  getPostById(id: any, action = null): Observable<any> {
    console.log(id, "service");
    let data = { id: null, action: true };
    data.id = id;
    if (action === false) {
      data.action = false;
    }
    return this.http.post<any>(this.url + "feed/getpostById", data);
  }

  getPostByPostId(id: any): Observable<any> {
    return this.http.get<any>(this.url + "feed/getpostByPostId/" + id);
  }

  updatePost(value: any, id: any, fileStatus: any): Observable<any> {
    console.log(value, fileStatus);

    const Data = JSON.stringify(value.mentionedUsers);
    let formData: FormData = new FormData();
    formData.append("title", value.title);
    formData.append("content", value.content);
    formData.append("id", id);
    formData.append("mentionedUsers", Data);
    formData.append("changed", fileStatus);
    formData.append("eventImage", value.file || null);
    return this.http.post<any>(this.url + "feed/updatePost", formData);
  }

  deletePost(id: any): Observable<any> {
    return this.http.delete<any>(this.url + "feed/deletePost/" + id);
  }

  postImage(images: any): Observable<any> {
    let formData: FormData = new FormData();
    formData.append("images", images);
    return this.http.post<any>(this.url + "feed/feedImageUpload", formData);
  }

  buildingPost(id: any): Observable<any> {
    let formData: FormData = new FormData();
    formData.append("id", id);
    return this.http.post<any>(this.url + "feed/getPostForBuilding", formData);
  }

  activityLikes(activityId: any, id: any): Observable<any> {
    let formData: FormData = new FormData();
    formData.append("activityId", activityId);
    formData.append("userId", id);
    return this.http.post<any>(this.url + "feed/addUpvote", formData);
  }

  getTotalFeedCountByBuildingId(buildingId: any): Observable<any> {
    return this.http.get<any>(
      this.url + "building/" + buildingId + "/feed/count"
    );
  }

  private handleError(error: any): Observable<never> {
    console.error("An error occurred:", error);
    return throwError(error); // Return observable with error
  }
}
